var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/video"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7506 5.14232C17.409 4.95898 16.6923 4.76732 15.7173 5.45065L14.4923 6.31732C14.4007 3.72565 13.2757 2.70898 10.5423 2.70898H5.54232C2.69232 2.70898 1.58398 3.81732 1.58398 6.66732V13.334C1.58398 15.2507 2.62565 17.2923 5.54232 17.2923H10.5423C13.2757 17.2923 14.4007 16.2757 14.4923 13.684L15.7173 14.5506C16.234 14.9173 16.684 15.034 17.0423 15.034C17.3506 15.034 17.5923 14.9423 17.7506 14.859C18.0923 14.684 18.6673 14.209 18.6673 13.0173V6.98398C18.6673 5.79232 18.0923 5.31732 17.7506 5.14232ZM9.29232 9.48398C8.43398 9.48398 7.72565 8.78398 7.72565 7.91732C7.72565 7.05065 8.43398 6.35065 9.29232 6.35065C10.1507 6.35065 10.859 7.05065 10.859 7.91732C10.859 8.78398 10.1507 9.48398 9.29232 9.48398Z",
    fill: "#5D616F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectVideo);
export default __webpack_public_path__ + "static/media/object_video.682c1c5757d2e04362d5f949ff58cf56.svg";
export { ForwardRef as ReactComponent };